<template>
    <div class="btn" :style="{'width': wd, 'height': ht, 'border-radius': br}">
        <button @click="emitter(val)" :value="val" :style="{'border-radius': br, 'font-size': fz, 'color': cl}">{{name}}</button>
    </div>
</template>
<script>
export default {
    name: 'base-button',
    props: {
        name: {
            //需要默认值
            require: false,
            default: '提交',
        },
        value: {
            require: false,
        },
        wd: {
            require: false,
            default: '6.24rem',
        },
        ht: {
            require: false,
            default: '1rem',
        },
        br: {
            require: false,
            default: '.5rem',
        },
        fz: {
            require: false,
            default: '.36rem',
        },
        cl: {
            require: false,
            default: '#ffffff',
        },
    },
    created() {
        this.val = this.value
    },
    data() {
        return {
            val: '',
        }
    },
    methods: {
        emitter: function () {
            this.$emit('click', this.val)
        },
    },
}
</script>
<style lang="scss" scoped>
.btn {
    width: 6.24rem;
    height: 1rem;
    background: linear-gradient(0deg, #c4a160, #6f542b);
    border-radius: 0.5rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    button {
        width: calc(100% - .1rem);
        color: #ffffff;
        font-weight: bold;
        font-size: 0.36rem;
        text-align: center;
        height:  calc(100% - .1rem);
        line-height: calc(100% - .1rem);
        background: linear-gradient(0deg, #836638, #4f4023);
        border-radius: 0.5rem;
        cursor: pointer;
        transition: opacity 0.2s;
        outline: none;
        position: relative;
        &::before {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            height: 100%;
            background: linear-gradient(0deg, #624a23, #271d09);
            border: inherit;
            border-color: linear-gradient(0deg, #4b3719, #94763e);
            border-radius: inherit;
            transform: translate(-50%, -50%);
            opacity: 0;
            content: ' ';
        }
        &:active::before {
            opacity: 0.1;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/BaseButton.vue